module.exports = "/fonts/boxicons.svg?ac68c5bee58c439e4c2851555d41be8b";